module.exports = __webpack_public_path__ + "static/img/backBorder.7e86bfee.png";